<template>
  <div class="p--40px">
    <strong class="font--21px font--600 pb--24px block">회원 {{isEditMode ? '수정' : '생성'}}</strong>
    <form @submit.prevent="submit">
      <!-- <profile
        v-if="isEditMode"
        v-model="row.avatar"
        :userInfo="row"
      /> -->

      <div class="myinfo__body admin--myinfo clear pt--24px">
        <div
          class="info__modified clearfix"
          @input="error.errorMessage = ''"
        >
          <text-field-input
            :required="true"
            :error="error"
            v-model="row.userId"
            label="아이디"
            name="userId"
            :placeholder="''"
            :readonly="isEditMode"
          ></text-field-input>

          <text-field-input
            :required="true"
            :error="error"
            v-model="row.userName"
            label="이름"
            name="userName"
            :placeholder="''"
          ></text-field-input>

          <text-field-input
            :required="true"
            :error="error"
            v-model="row.email"
            label="이메일"
            name="email"
            :placeholder="''"
          ></text-field-input>

          <!-- <text-field-input
            v-if="isEditMode"
            type="password"
            v-model="row.passwordOld"
            label="기존 비밀번호"
            name="passwordOld"
            :error="error"
            :placeholder="''"
          ></text-field-input> -->

          <text-field-input
            type="password"
            v-model="row.password"
            label="새 비밀번호"
            name="text"
            :error="error"
            :placeholder="''"
          ></text-field-input>

          <!-- <text-field-input
            type="password"
            v-model="row.passwordConfirm"
            label="새 비밀번호 확인"
            name="passwordConfirm"
            :error="error"
            :placeholder="''"
          ></text-field-input> -->

          <text-field-toggle
            :error="error"
            v-model="row.emailFlag"
            true-value="Y"
            false-value="N"
            label="이벤트 수신여부"
            name="emailFlag"
            help-text="ON 으로 변경시 이벤트, 프로모션 등 다양한 정보를 전달 드립니다."
          ></text-field-toggle>

          <text-field-toggle
            :error="error"
            v-model="row.useFlag"
            true-value="Y"
            false-value="N"
            label="사용 여부"
            name="useFlag"
            help-text=""
          ></text-field-toggle>

          <!-- 
          <div
            class="clearfix event__reception py--20px"
            v-if="user.role === 'super'"
          >
            <div class="col-m-2">
              <p class="font--14px text--gray mt--8px">관리자 여부</p>
            </div>
            <div class="col-m-10">
              <div class="inline-block">
                <form-toggle
                  v-model="row.role"
                  true-value="admin"
                  false-value="user"
                ></form-toggle>
              </div>
            </div>
          </div> -->

        </div>
        <div class="text--center py--40px">
          <form-button
            label="취소"
            class="btn btn--xxxl border border--gray mr--8px"
            @click="$router.go(-1)"
          ></form-button>
          <form-button
            type="submit"
            label="저장"
            class="btn btn--xxxl black text--white"
          ></form-button>
        </div>
      </div>
    </form>

  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      row: {
        role: 'user1',
        emailFlag: 'Y',
        useFlag: 'N'
      },
      origin: {},
      error: {}
    }
  },
  computed: {
    ...mapState(['user']),
    isEditMode () {
      return !!this.$route.params.userId
    },
    userId () {
      return this.$route.params.userId
    }
  },
  created () {
    if (this.isEditMode) {
      this.$load(`/api/users/${this.userId}`)
    }
  },
  methods: {
    async submit () {
      // this.$emit('submit')
      try {
        // this.checkPassword()
        if (!this.isEditMode) {
          await this.$create(`/api/users`)
          this.$router.push({ name: 'adminMember' })
        } else {
          await this.$update(`/api/users/${this.row.userId}`)
          this.$router.go(-1)
        }
      } catch (error) {
        this.error = error
      }
    },
    checkPassword () {
      let res = false
      if (!this.isEditMode) {
        res = !this.row.password || (this.row.password !== this.row.passwordConfirm)
      } else {
        res = (this.row.password || this.row.passwordOld) && (!this.row.password || this.row.password !== this.row.passwordConfirm)
      }
      if (res) {
        window.scrollTo(0, 0)
        const error = {
          fieldId: 'password',
          errorMessage: '패스워드가 일치하지 않습니다.'
        }
        throw error
      }
    }
  },
  components: {
    // Profile: () => import('@/component/common/Profile'),
    FormButton: () => import('@/component/ui2/button/FormButton'),
    TextFieldInput: () => import('@/component/ui2/textfield/TextFieldInput'),
    // TextFieldSelect: () => import('@/component/ui2/textfield/TextFieldSelect'),
    TextFieldToggle: () => import('@/component/ui2/textfield/TextFieldToggle')
  }
}
</script>
